export function formatCurrency(value: number | null | undefined) {
  return value != null ? (value / 100).toFixed(2) : '';
}
